import { itemsPerPage } from 'core/constants/pagination.constants';
import { DEFAULT_PAGE } from 'core/constants/platform.constants';
import type { IOrdersState } from './orders.type';

export const SLICE_NAMESPACE = 'orders';

export const initialState: IOrdersState = {
  filters: {
    ByOrder: '',
    ByClient: '',
  },
  orderList: {
    isLoading: false,
    isSuccess: false,
    error: null,
    data: [],
  },
  orderListPagination: {
    totalItems: 0,
    totalPages: 0,
    currentPage: DEFAULT_PAGE,
    itemsPerPage,
  },
  orderDetail: {
    isLoading: false,
    isSuccess: false,
    error: null,
    data: null,
  },
};
